<template>
        <slot name="navbar" v-bind="this"></slot>
</template>


<script>
    export default {
        props: {
            cartAdded: null,
            resetCartAdded: Function,
            initialCartCount: { type: Number, required: true },
            cartPayload: null
        },
        data(){
            return {
                showModal: false,
                cartCount: this.initialCartCount || 0,
            }
        },

        methods: {
            closeModal(){
                this.showModal = this.cartAdded;
                this.resetCartAdded();
            },

            incrementCartCount() {
                this.cartPayload;
            },

        },


        watch: {
            cartAdded(newVal, oldVal){
                if(newVal && !oldVal) {
                    this.closeModal();
                    this.incrementCartCount();
                    this.resetCartAdded();
                }
            },

            cartPayload(newVal) {
                if (newVal) {
                    if (newVal.totalQty !== undefined && !isNaN(newVal.totalQty)) {
                        this.cartCount = Number(newVal.totalQty);
                    } else if (newVal.productQuantity !== undefined && !isNaN(newVal.productQuantity)) {
                        this.cartCount += Number(newVal.productQuantity);
                    }
                }
            }
        },

    }
</script>
